<script>
import ListDefault from "../Utils/Page/ListDefault.vue";
import {mapGetters} from "vuex";

export default {
    name: "BrainHealthList",

    mixins: [ListDefault],

    data() {
        return {
            lang: this.$ml.get('pages.BrainHealth'),

            isVisibleCreateButton: false,
            isVisibleEditButton: false,

            apiList: this.$store.getters.getApiUrl('brainHealth'),
            pageRoute: 'violation-reports',
            pagePermission: 'artifact.brain-health',

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'path_func', is_sort: false, classes: 'text-l' },
                { key: 'path_lld', is_sort: false, classes: 'text-l' },
                { key: 'brain_health_id', is_sort: true, classes: 'text-l' },
                { key: 'user', is_sort: false, classes: 'text-l' },
                { key: 'processing_date', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                brain_health_id: { type: 'function', function: this.getBrainHealthId },
                path_func: { type: 'function', function: this.getPathFunc },
                path_lld: { type: 'function', function: this.getPathLLD },
                user: { type: 'function', function: this.getUser },
            },
        }
    },

    methods: {
        getBrainHealthId(item) {
            return item.user?.brain_health_id ?? '-'
        },
        getPathFunc(item) {
            let link = '/api/administrator/brain-health-download/' + item.path_func
            return `<a href="${link}">${item.path_func}</a>`
        },
        getPathLLD(item) {
            let link = '/api/administrator/brain-health-download/' + item.path_lld
            return `<a href="${link}">${item.path_lld}</a>`
        },
        getUser(item) {
            if (!this.getPermissionSection('edit')) {
                return '-'
            }
            let user = '@' + item.user.name
            let link = this.$router.resolve({name: 'user.edit', params: {id: item.user.id}})
            return `<a href="${link.href}" class="link">${user}</a>`
        }
    }
}
</script>
